module.exports = __webpack_public_path__ + "static/media/ic-admin-btn-pass-reset.00a64c33.svg";